import "./Maryland.module.css";
import Header from "@/reusable_sections/Header";
import MarylandHero from "./sections/MarylandHero";
import MarylandArea from "./sections/MarylandArea";
import EmergencyCta from "./sections/EmergencyCta";
import Footer from "@/reusable_sections/Footer";
export default function MarylandPage() {
  return <div>
      <Header />
      <MarylandHero />
      <MarylandArea />
      <EmergencyCta />
      <Footer />
    </div>;
}